export const NUMBERS = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    TEN: 10,
    TWELVE: 12,
    FIFTEEN: 15,
    FIFTY: 50,
    SIXTY: 60,
    HUNDRED: 100,
    TWO_HUNDRED: 200,
    FOUR_HUNDRED: 400,
    FOUR_HUNDRED_FOUR: 404,
    FIVE_HUNDRED: 500,
    FIVE_HUNDRED_TWO: 502,
    FIVE_HUNDRED_THREE: 503,
    FIVE_HUNDRED_FOUR: 504,
    THOUSAND: 1000,
    TWO_THOUSAND: 2000,
    THREE_THOUSAND: 3000,
    FIVE_THOUSAND: 5000,
};

export const PROFILE_STATUS = {
    ACCOUNT_VERIFICATION_IN_PROGRESS : 1,
    PROFILE_IN_PROGRESS : 2,
    ADMIN_VERIFICATION_IN_PROGRESS : 3,
    ADMIN_REJECTED : 4,
    COMPLETED : 5,
    INACTIVE: 6,
};

export const USER_ROLE = {
    EMPLOYER: 1,
    CANDIDATE: 2,
    ADMIN: 3,
    SUPER_ADMIN: 4
};

export const SOCIAL_PLATFORM = {
    LINKED_IN: 1,
    INDEED: 5
};

export const SIZE_IN_BYTES = 1024;
